module.exports = __webpack_public_path__ + "assets/ffd977811678f28152a046cfc092736e.mp4";